import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { UpdateProductRequest } from 'src/types/catalog/UpdateProduct';
import axiosInstance from 'src/utils/axios';

async function updateProduct(request: UpdateProductRequest): Promise<void> {
  await axiosInstance.put(api.updateProduct, request);
}

interface UseUpdateProductMutationOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

const useUpdateProductMutation = ({
  onSuccess,
  onError,
}: UseUpdateProductMutationOptions = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.product.root],
      });
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error as Error);
    },
  });

  return mutation;
};

export default useUpdateProductMutation;

